<template>
  <div class="container">
    <Title>Feedback</Title>

    <div v-if="isLoading" class="loading card-section">
      Loading feedback...
    </div>

    <div v-else-if="error" class="error card-section">
      {{ error }}
    </div>

    <div v-else class="card-section">
      <h3>Feedback Submissions</h3>
      <p v-if="feedbackItems && feedbackItems.length > 0" class="average-rating">
        Average rating: <strong>{{ averageRating }}</strong>
      </p>

      <div v-if="feedbackItems && feedbackItems.length > 0" class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Date</th>
              <th>Time</th>
              <th>Rating</th>
              <th>Comment</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in feedbackItems" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.date }}</td>
              <td>{{ item.time }}</td>
              <td>{{ item.rating > 0 ? item.rating : 'No rating' }}</td>
              <td>{{ item.comment }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="no-data">
        No feedback available.
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '@/services/apiService';
import Title from './components/Title.vue';

export default {
  name: 'FeedbackDisplayPage',
  components: {
    Title
  },
  data() {
    return {
      feedbackItems: [],
      isLoading: true,
      error: null
    };
  },
  computed: {
    averageRating() {
      if (!this.feedbackItems || this.feedbackItems.length === 0) return 'No ratings yet';
      const nonZeroRatings = this.feedbackItems.filter(item => item.rating > 0);
      if (nonZeroRatings.length === 0) return 'No ratings yet';
      const sum = nonZeroRatings.reduce((acc, item) => acc + item.rating, 0);
      return (sum / nonZeroRatings.length).toFixed(2);
    }
  },
  mounted() {
    this.loadFeedback();
  },
  methods: {
    async loadFeedback() {
      this.isLoading = true;
      this.error = null;
      try {
        const response = await apiService.fetchFeedback();
        this.feedbackItems = response.feedback || [];
      } catch (error) {
        console.error("Error loading feedback:", error);
        this.error = "Failed to load feedback. Please try again later.";
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
  color: #323232;
}

.title {
  color: #323232;
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
  border-bottom: 2px solid #42b983;
  padding-bottom: 0.5rem;
  display: inline-block;
}

.card-section {
  background-color: white;
  border-radius: 6px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

h3 {
  color: #323232;
  font-size: 1.2rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.average-rating {
  margin-bottom: 1rem;
  font-size: 16px;
}

.average-rating strong {
  color: #42b983;
  font-weight: 700;
}

.table-wrapper {
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e8e9f5;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 14px;

}

th,
td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #e8e9f5;
  font-weight: 500;
}

th {
  background-color: #e8f4f0;
  font-weight: 700;
  color: #323232;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

tr:last-child td {
  border-bottom: none;
}

tr:hover {
  background-color: #f9f9f9;
}

.error {
  background-color: #f8d7da;
  color: #dc3545;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 1.5rem;
  border: 1px solid #f5c6cb;
}

.loading {
  text-align: center;
  padding: 24px;
  color: #42b983;
}

.no-data {
  text-align: center;
  padding: 24px;
  color: #505050;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .container {
    padding: 1rem;
  }

  td,
  th {
    padding: 8px;
  }
}
</style>